import { useEffect, useState } from "react"
import { getStats } from "../../api"
import { Heading, Loading, Select } from "../../components"
import { ECathegory, ECypherType, EHelpType, TCypher, TStats, TUser } from "../../types"
import './stats.scss';
import { BiRefresh } from 'react-icons/bi';
import { useAppState } from "../../hooks";
import { GAMES, gameType } from "../../utils";

export const Stats = () => {
    const [stats, setStats] = useState<TStats>()
    const [loading, setLoading] = useState(false)
    const { state } = useAppState()

    useEffect(() => {
        refresh()
    }, [])

    const refresh = () => {
        setLoading(true)
        getStats({ token: state?.token }).then(res => {
            if (res.stats) {
                setStats(res.stats)
            }
        }).finally(() => setLoading(false))
    }

    const FirstRow = () => {
        if (!stats) {
            return <></>
        } else {
            return (
                <div className='stats__first_row'>
                    <div className='stats__collumn_order'></div>
                    <div className='stats__collumn_team'></div>
                    {stats.cyphers.filter(c => (c.type === ECypherType.CYPHER || c.type === ECypherType.START)).map(c => <div className='stats__collumn_cypher_time'>{c.Id}</div>)}
                    <div className='stats__collumn_cypher_time'>Cíl</div>
                    {stats.cyphers.filter(c => c.type === ECypherType.BONUS).map(c => <div className='stats__collumn_cypher_time'>{'B'}</div>)}
                    {
                        {
                            0: <div className='stats__collumn_time'>Body</div>,
                            1: '',
                            2: ''
                        }[gameType()]
                    }
                    <div className='stats__collumn_time'>Celkový čas</div>
                </div>
            )
        }
    }

    const getCypherTeamTime = (c: TCypher | undefined, t: TUser) => {
        if (c == undefined) { return '' }
        const time = stats?.teamCyphers.find(tc => tc.id_cypher === c.Id && tc.id_team === t.Id)?.time
        if (time) {
            const date = new Date(time)
            return `${date.getHours()}:${date.getMinutes().toLocaleString('cs-CS', { minimumIntegerDigits: 2, useGrouping: false })}`
        } else return ''
    }

    const getPrintableTime = (date: Date | undefined) => {
        if (date == undefined) {
            return ''
        }
        return date.toString()
    }

    const getHelpClass = (c: TCypher, t: TUser) => {

        let helps = stats?.teamHelps?.filter(th => th.id_team === t.Id && th.help.cypher === c.Id).map(h => h.help)
        if (!helps || helps.length == 0) {
            return ''
        }
        
        if (helps.find(h => h.type === EHelpType.ABSOLUTE)) {
            return 'help_absolute'
        } else if (helps.find(h => h.type === EHelpType.INSTRUCTIONS)) {
            return 'help_instructions'
        } else if (helps.find(h => h.type === EHelpType.NORMAL)) {
            return 'help_normal'
        } else if (helps.find(h => h.type === EHelpType.MINI)) {
            return 'help_mini'
        }
        return ''
    }

    const getTooltip = (c: TCypher, t: TUser) => {
        let helps = stats?.teamHelps?.filter(th => th.id_team === t.Id && th.help.cypher === c.Id).map(h => h.help).sort((a,b) => a.order - b.order)
        if (!helps || helps.length == 0) {
            return undefined
        }

        return (
            <span className="tooltip">{helps.map(h => `${h.order}${h.type}(-${h.points})`).join(', ')}</span>
            )
    }


    const TeamRows = () => {
        if (!stats) {
            return <></>
        } else {
            return (
                <>
                    {stats?.teams.map(
                        (t, i) =>
                            <div className='stats__row'>
                                <div className={'stats__collumn_order' + (t.GameInfo?.Status === 5 ? ' surrended' : '')}>{`${i + 1}.`}</div>
                                <div className={'stats__collumn_team' + (t.GameInfo?.Status === 5 ? ' surrended' : '')}>{t.Name}</div>
                                {stats.cyphers.filter(c => c.type === ECypherType.START).map(c => <div className='stats__collumn_cypher_time'>{getCypherTeamTime(c, t)}</div>)}
                                {stats.cyphers.filter(c => c.type === ECypherType.CYPHER).map(c => <div className={`stats__collumn_cypher_time ${getHelpClass(c, t)}`}>{getCypherTeamTime(c, t)}{getTooltip(c, t)}</div>)}
                                {stats.cyphers.filter(c => c.type === ECypherType.FINISH).map(c => <div className='stats__collumn_cypher_time'>{getCypherTeamTime(c, t)}</div>)}
                                {stats.cyphers.filter(c => c.type === ECypherType.BONUS).map(c => <div className='stats__collumn_cypher_time'>{getCypherTeamTime(c, t)}</div>)}
                                {
                                    {
                                        0: < div className='stats__collumn_time'>{t.GameInfo?.points}</div>,
                                        1: '',
                                        2: ''
                                    }[gameType()]
                                }
                                {<div className='stats__collumn_time'>{getPrintableTime(t.GameInfo?.totalTime)}</div>}
                            </div>
                    )
                    }
                </>
            )
        }
    }

    if (loading) {
        return <Loading/>
    }

    return (
        <>
            <Heading headline='Průchod týmů' weight={1} />
            <div className='refresh'>
                <BiRefresh onClick={refresh} size={25} />
            </div>

            <div className='statsContainer'>
            <div className='stats'>
                <div className='stats__container'>
                <FirstRow />
                    <TeamRows />
                </div>
                </div>
            </div>
        </>
    )
} 